import React, {ReactElement} from "react";
import {DIALOG_FLAG_SHOW_DIALOG_FULLSCREEN} from "../../shared/BaseSite";
import {BaseApp} from "../../shared/BaseApp";
import {StyledBoxColumn} from "@/shared/StyledComponents";
import {GalleryUploadFile} from "./GalleryUpload";
import {DialogFragment, PageFragment, PageFragmentProps, PageFragmentStyleFlags} from "../../shared/PageFragment";
import {StlViewFragment} from "./modelview/stl/StlViewFragment";

export class GalleryHelper {

  static showGalleryDialog(files: GalleryUploadFile[], selectedIndex?: number): void {
    const context = BaseApp.CONTEXT;
    const id = context.showDialog(
      {flags:  DIALOG_FLAG_SHOW_DIALOG_FULLSCREEN},
      () => <GalleryFragment files={files} selectedIndex={selectedIndex} onBack={() => BaseApp.CONTEXT.hideDialog(id)}/>
    );
  }
}

export type GalleryFragmentProps = PageFragmentProps & {
  files: GalleryUploadFile[],
  selectedIndex?: number,
  onBack: () => void,
}

export class GalleryFragment extends DialogFragment<GalleryFragmentProps> {

  protected getTitle(): string | null | undefined {
    return "Viewer";
  }

  getIntrinsicHeight(): number | string {
    return "100dvh";
  }

  protected styleFlags(): number | PageFragmentStyleFlags {
    return PageFragment.STYLE_BACK_BUTTON_FLAG;
  }

  onBackButtonClicked() {
    this.props.onBack();
  }

  renderContent(): ReactElement {
    return <StyledBoxColumn
      style={{
        display: "flex",
        height: "100%",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "white",
      }}>
      <StlViewFragment sceneUrl={this.props.files[0].url} />
    </StyledBoxColumn>;
  }
}